import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { projectMembershipOptions } from '@/module/Nomen/ProjectMembership/model/ProjectMembershipModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type ProjectMembershipSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ProjectMembershipSelectControl<T extends FieldValues>(props: ProjectMembershipSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(projectMembershipOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
